module.exports = __webpack_public_path__ + "img/233.fd20287a.jpg";